import React from 'react'
import './Servicegrid.css'

const Servicegrid = () => {
    const services = [
        {
            no: '01',
            title: 'Software Development',
            desc: 'Custom internal tools, ERPs and SaaS platforms built to scale with your business.',
            tags: ['Laravel', '.NET', 'Node.js', 'PostgreSQL']
        },
        {
            no: '02',
            title: 'Web Development',
            desc: 'High-performance marketing sites and web apps. Fast, accessible, SEO-ready out of the box.',
            tags: ['React', 'Next.js', 'WordPress', 'Webflow'],
            featured: true
        },
        {
            no: '03',
            title: 'Mobile Apps',
            desc: 'Native and hybrid apps for iOS and Android. From MVPs to production-grade PWAs.',
            tags: ['React Native', 'Flutter', 'Swift', 'PWA']
        },
        {
            no: '04',
            title: 'SEO & Growth',
            desc: 'Technical SEO, content strategy and CRO that compounds and is built into the product.',
            tags: ['On-page', 'Off-page', 'Local', 'Technical']
        },
        {
            no: '05',
            title: 'Digital Marketing',
            desc: 'Paid acquisition, lifecycle and analytics measured by pipeline, not vanity metrics.',
            tags: ['Google Ads', 'Meta', 'Email', 'Analytics']
        },
        {
            no: '06',
            title: 'Brand & UX',
            desc: 'Identity systems, product design and motion. Designed in Figma, shipped by our team.',
            tags: ['Identity', 'Product UX', 'Design Systems', 'Motion']
        },
        {
            no: '07',
            title: 'Artificial Intelligence',
            desc: 'AI copilots, workflow automation and LLM integrations tailored to your operations.',
            tags: ['LLM Apps', 'RAG', 'Automation', 'AI Agents']
        }
    ];

    return (
        <section className="sgrid-wrapper">
        <div className="innerWidth">
            <p className="sgrid-eyebrow">SERVICES</p>
            <h2 className="sgrid-title">
                Everything you need to <span>ship</span>, in one team.
            </h2>
            <p className="sgrid-subtitle">
                Six disciplines, one Slack channel, one invoice. We replace the agency stack.
            </p>
            <div className="Scard-caontainer">
                {
                    services.map((card, i)=>(
                        <div key={i} className={`s-card ${card.featured ? 'is-featured' : ''}`}>
                            <div className="s-card-top">
                                <span className="s-card-no">{card.no}</span>
                                {/* <span className="s-card-arrow">↗</span> */}
                            </div>
                            <h3>{card.title}</h3>
                            <p>{card.desc}</p>
                            <div className="s-card-tags">
                                {card.tags.map((tag) => (
                                    <span key={tag}>{tag}</span>
                                ))}
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
        </section>
    )
}

export default Servicegrid
